import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getDownLoadFormLabels,
  getDownLoadFormBanner,
} from '../../selectors/downLoadFormSelectors';
import { getSelectedPolicy } from '../../selectors/changeContactSelector';
import { resolveLocalizedText, resolvePublicAssets } from '../../../../utils';
import BackNavButton from '../../components/BackNavButton';
import EmmaNavTitle from '../../../../components/EmmaNavTitle';
import CustomerProfileTitle from '../../components/CustomerProfileTitle';
import browserHistory from '../../../../stores/browserHistory';
import './style.scss';
import { t } from '../../../../locales';

export interface DownLoadFormContainerProps {
  title: string;
  icon: string;
  descTitle: string;
  desc: string;
  buttonText: string;
  downLoadUrl: string;
  selectedPolicy: any;
}

export interface DownLoadFormContainerState {
  isShowModal: boolean;
}

export class DownLoadFormContainer extends Component<
  DownLoadFormContainerProps,
  DownLoadFormContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShowModal: true,
    };
  }

  componentDidMount() {}

  onGoBack = () => {
    const { selectedPolicy = {} } = this.props;
    browserHistory.goBack();
    browserHistory.goBack();
    // goto(`emma-customer-profile/contact-details?policy_number=${selectedPolicy.policyNumber}`);
  };

  render() {
    const { title, icon, descTitle, desc, buttonText, downLoadUrl } =
      this.props;
    return (
      <div className="download-service-form">
        <BackNavButton onClick={this.onGoBack} blue title={t('BACK')} />
        <div className="emma-stylesheet-grid-system">
          <EmmaNavTitle
            title={title}
            component={<CustomerProfileTitle customerTitle={title} />}
          />
          <div className="download-service-form-img">
            <img src={icon} alt="" />
          </div>
          <div className="download-service-form-text">{descTitle}</div>
          <div>{desc}</div>
          <div className="download-service-form-button">
            <a target="_blank" rel="noopener noreferrer" href={downLoadUrl}>
              <button
                data-enable-ga
                data-ga-type="button"
                className="emma-stylesheet-primary-default-button"
              >
                {buttonText}
              </button>
            </a>
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const selectedPolicy = getSelectedPolicy(state);
    const labels = getDownLoadFormLabels(state) || {};
    const banner = getDownLoadFormBanner(state) || {};
    const { title } = labels;
    const { icon, descTitle, desc, buttonText, downLoadUrl } = banner;
    return {
      selectedPolicy,
      title: title ? resolveLocalizedText(title) : '',
      icon: icon
        ? resolvePublicAssets(
            `assets/${icon.replace('images/', 'images/customer-profile/')}`,
          )
        : '',
      descTitle: descTitle ? resolveLocalizedText(descTitle) : '',
      desc: desc ? resolveLocalizedText(desc) : '',
      buttonText: buttonText ? resolveLocalizedText(buttonText) : '',
      downLoadUrl,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  DownLoadFormContainer.mapStateToProps,
  DownLoadFormContainer.mapDispatchToProps,
)(DownLoadFormContainer);
